import { DbOrderProductInfos } from "./db-order-product-infos";
import { DbOrderManualTaskTemplateFormFieldInfos } from "./db-order-manual-task-template-form-field-infos";
import { ManualTasksTemplateDisabledTasks } from "./manual-tasks-template-disabled-tasks";

export class BasketItemOptions {
  itemId: number | null = 0;
  manualTasksTemplateId: number | null = 0;
  productWithOptions: DbOrderProductInfos | null = null;
  manualTasksTemplateFormFields: DbOrderManualTaskTemplateFormFieldInfos[] | null = null;
  manualTasksTemplateDisabledTasks: ManualTasksTemplateDisabledTasks[] | null = null;
  includeOnlyAvailableValues: boolean | null = null;
  orderScheduledTime: Date | null = null;

  constructor(init?: Partial<BasketItemOptions>) {
    Object.assign(this, init);
  }
}
